import {Component, Prop, Watch} from 'vue-property-decorator'
import {TemplateMaintenaceViewmodal} from './template-maintenance.viewmodal'
import {namespace} from 'vuex-class'
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS_FORCE} from '../../../../store/search'
import {SearchEntities, UserTemplate} from '../../../../common/enums'
import {MAINTENANCE_GET_INTERVAL_TYPES, MAINTENANCE_GET_TEMPLATES, MAINTENANCE_MODULE_NAMESPACE} from '../../../../store/maintenance'
import { AgencyManagementService, MaintenanceService, TicketService } from '../../../../services'
import { eventBus } from '../../../../main'
import { IUserDetails } from '../../../../models/user';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE);
@Component({
  components: {
    'ticket-group-round-buttons': async () => import('../../../ticket/components/ticket-modal-group-round-buttons/TicketModalGroupRoundButtons.vue'),
    'mandate-quote-selector': async () => import('../../../ticket/components/ticket-mandate-or-quote-selector/TicketMandateOrQuoteSelector.vue')
  }
})
class TemplateMaintenanceModalVertical extends TemplateMaintenaceViewmodal {

  @Prop({default: false, type: [Boolean]})
  isUpdateTemplateMaintenance: boolean

  @Prop({default: {}, type: [Object]})
  templateMaintenanceData: any





  @Watch('FKEquipmentCategory')
  async equipmentCategoryChanged(val){
    this.FKEquipmentSubCategory = null
    if(val && !this.isUpdateTemplateMaintenance)
    {
      this.isLoading = true
      this.attributes = []
      const response:any = await this.getAttributes(val)
      response.attributes.filter((item:{used_by_maintenance:boolean})=> item.used_by_maintenance===true ).map(item=>this.attributes.push(item))
      this.isLoading = false
    }
  }

  @Watch('FKEquipmentSubCategory')
  async equipmentSubCategoryChanged(val){

    if(val && !this.isUpdateTemplateMaintenance)
      {
        this.isLoading = true
        this.attributes = []
        const response_lvl1:any = await this.getAttributes(this.FKEquipmentCategory.toString())
        response_lvl1.attributes.filter((item:{used_by_maintenance:boolean})=> item.used_by_maintenance===true ).map(item=>this.attributes.push(item))
        const response_lvl2:any = await this.getAttributes(val)
        response_lvl2.attributes.filter((item:{used_by_maintenance:boolean})=>  item.used_by_maintenance===true ).map(item=>this.attributes.push(item))
        this.isLoading = false
      }
  }






  @Watch('FKMaintenanceIntervalType')
  intervalTypeChanged(val)
  {
    if(val && !this.isUpdateTemplateMaintenance){
      if(!this.isUpdateTemplateMaintenance){
        this.interval = null
        this.alertPreDelay = null
      }
      const intervalType = this.maintenanceIntervalTypes.find(item=>item.id===val)
      this.intervalUnit = intervalType.name
      this.alertUnit = 'Jour'
    }
  }

  @Watch('FKAttribute')
  attributChanged(val)
  {
    if(val && !this.isUpdateTemplateMaintenance)
    {
      const attribut = this.attributes.find(item=>item.id===val)
      if(!this.isUpdateTemplateMaintenance){
        this.FKMaintenanceIntervalType = null
        this.interval = null
        this.alertPreDelay = null
      }
      this.attributType = attribut.attribute_type.type
      if(attribut.attribute_value)
      {
        if(this.attributType==='number')
        {
          this.FKMaintenanceIntervalType = 1
          this.$nextTick(()=>{
            this.intervalUnit = attribut.unit
            this.alertUnit = attribut.unit
          })
        }
      }
      else
      {
        this.FKMaintenanceIntervalType = 1
        this.$nextTick(()=>{
          this.intervalUnit = attribut.unit
          this.alertUnit = attribut.unit
        })
      }
    }
    else
    {
      this.attributType = 'date'
      this.FKMaintenanceIntervalType = null
    }
  }



  @MaintenanceStore.Getter maintenanceIntervalTypes: { name: string, id: number, type:string }[]

  @MaintenanceStore.Action(MAINTENANCE_GET_TEMPLATES)
  storeGetMaintenanceTemplate: (params:any) => Promise<any>;

  @MaintenanceStore.Action(MAINTENANCE_GET_INTERVAL_TYPES)
  storeGetMaintenanceIntervalTypes: () => Promise<any>;


  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetMasterData: (payload?: { keys: SearchEntities[] }) => Promise<any>;


  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;
  @UserStore.Getter userInfo: IUserDetails;
  dtRules: {}
  isCategoriesLoading:boolean;
  charProblemAPI:any
  maintenanceAPI:any
  equipmentCategories:any[]
  equipmentSubCategories:any[]
  equipments:any[]
  attributes:any[]
  intervalUnit:string
  alertUnit:string
  attributType:string
  dialog:{isOpen:boolean, title:string, message:string, btnText:string, action:Function}
  isLoading:boolean
  AM:AgencyManagementService

  constructor() {
    super()
    this.dtRules = {}
    this.type = 'mandatory'
    this.isCategoriesLoading = true
    this.charProblemAPI = new TicketService()
    this.maintenanceAPI = new MaintenanceService()
    this.AM = new AgencyManagementService()

    this.equipmentCategories = []
    this.equipmentSubCategories = []
    this.equipments = []
    this.attributes = []
    this.FKEquipmentCategory = null
    this.FKEquipmentSubCategory = null
    this.intervalUnit = null
    this.alertUnit = null
    this.attributType = 'date'
    this.dialog = {
      isOpen:false,
      title:'title',
      message:'message',
      btnText:'Action',
      action:()=>{console.log('Action')}
    }
    this.isLoading = false
  }

  beforeDistroy()
  {
    eventBus.$off('SET_ISLOADING_MODAL_TEMPLATE_MAINTENANCE')
  }

  async beforeMount() {

    eventBus.$on('SET_ISLOADING_MODAL_TEMPLATE_MAINTENANCE',val=>{
      this.isLoading = val
    })

    this.dtRules = {
      nameRules: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelTemplateMaintenanceName)})],
      descriptionRules:[v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelTemplateMaintenanceDescription)})],
      typeRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceType)})],
      CategorieRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceEquipementCategorie)})],
      IntervalTypeRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceIntervalType)})],
      IntervalRules:[v=> !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.labelMaintenanceInterval)})],
    }

    this.isLoading = true
    await this.storeGetMaintenanceIntervalTypes()
    const _categories = await this.charProblemAPI.getCharacterProblems()
    this.equipmentCategories = _categories.level_1
    this.isCategoriesLoading = false

    if(this.isUpdateTemplateMaintenance)
    {
      this.type = this.templateMaintenanceData.type
      this.name = this.templateMaintenanceData.name
      this.description = this.templateMaintenanceData.description

      this.FKEquipmentCategory = this.templateMaintenanceData.fk_character_problem

      this.$nextTick(()=>{
        this.FKEquipmentSubCategory = this.templateMaintenanceData.fk_character_problem_level_2
        this.FKMaintenanceIntervalType = this.templateMaintenanceData.fk_maint_interval_type
        this.interval = this.templateMaintenanceData.interval
        this.alertPreDelay = this.templateMaintenanceData.alert_pre_delay

        if(!this.templateMaintenanceData.attribute)
        {
          this.intervalUnit = this.templateMaintenanceData.interval_type.name
          this.alertUnit = 'Jours'
        }
        else
        {
          this.attributes = [{id:this.templateMaintenanceData.attribute.id, name:this.templateMaintenanceData.attribute.name}]
          this.FKAttribute = this.templateMaintenanceData.fk_maint_attribute
          this.$nextTick(()=>{
            this.attributType = this.templateMaintenanceData.attribute.attribute_type.type
            this.FKMaintenanceIntervalType = this.templateMaintenanceData.fk_maint_interval_type
            this.intervalUnit = this.templateMaintenanceData.attribute.unit
            this.alertUnit = this.templateMaintenanceData.attribute.unit
          })
        }

        this.isLoading = false
      })
    } else {
      this.isLoading = false
    }



  }

  fetchTemplates(val)
  {
    return this.storeGetMaintenanceTemplate({q:val,$limit:50})
  }


  getAttributes(id:string)
  {
    return this.AM.getCharacterProblem(id)
  }

  get lblSetting() {
    return {
      ...require('@/locales/maintenance').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get textConfigs() {
    return require('@/assets/json-resources/text-field-configs.json')
  }
  get isServiceBookAgency():boolean {
    return this.userInfo.template === UserTemplate.serviceBookAgency
  }
  get isServiceBookOwner():boolean {
    return this.userInfo.template === UserTemplate.serviceBookOwner
  }
  get coTypes() {

    if(this.isServiceBookAgency || this.isServiceBookOwner)
      return [
        {key: 1, translationKey: 'Obligatoire', value: 'mandatory'},
        {key: 2, translationKey: 'Standard', value: 'default'}
      ]
    return [
      {key: 1, translationKey: 'Obligatoire', value: 'mandatory'},
      {key: 2, translationKey: 'Externe', value: 'external'},
      {key: 3, translationKey: 'Interne', value: 'internal'},
    ]
  }

  get coType() {
    if(this.isServiceBookAgency || this.isServiceBookOwner)
    return [
      {id:'mandatory',name:'Obligatoire'},
      {id:'default',name:'Standard'},
    ]
    return [
      {id:'mandatory',name:'Obligatoire'},
      {id:'external',name:'Externe'},
      {id:'internal',name:'Interne'}
    ]
  }

  get coMaintenanceIntervalType() {
    return this.maintenanceIntervalTypes.filter(item=>item.type!=='value');
  }



  get coEquipmentCategories()
  {
    return this.equipmentCategories
  }


  get coEquipmentSubCategories()
  {
    let r:any = this.equipmentCategories.find((cat:{id:number})=>cat.id===this.FKEquipmentCategory)
    return r? r.level_2 : []
  }


  get coAttributes()
  {
    return this.attributes
  }

}

export default TemplateMaintenanceModalVertical



// WEBPACK FOOTER //
// ./src/containers/profile/components/template-maintenance-modal-vertical/index.ts